export const searchParams = {
  includeDeleted: false,
  pageNumber: 1,
  pageSize: 15,
  orderBy: "id",
  orderDirection: "asc",
  search:""
};